"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var StandardViewState_1 = require("./StandardViewState");
/** Platform UI Components */
var Label_1 = require("@idp/ui-components/components/atoms/Label");
var TextField_1 = require("@idp/ui-components/components/atoms/TextField");
var TextFieldProps_1 = require("@idp/ui-components/components/atoms/TextField/TextFieldProps");
var Link_1 = require("@idp/ui-components/components/atoms/Link");
var LinkProps_1 = require("@idp/ui-components/components/atoms/Link/LinkProps");
var Button_1 = require("@idp/ui-components/components/atoms/Button");
var ButtonProps_1 = require("@idp/ui-components/components/atoms/Button/ButtonProps");
var Tooltip_1 = require("@idp/ui-components/components/atoms/Tooltip");
var TooltipProps_1 = require("@idp/ui-components/components/atoms/Tooltip/TooltipProps");
var Checkbox_1 = require("@idp/ui-components/components/atoms/Checkbox");
/** CMS */
var cms_integration_1 = require("@idp/cms-integration");
var globalStyles = require("../../../../styles/att-global.scss");
var inlineStyles = require("../../../common/InlineError/InlineError.scss");
var appStyles = require("../../../../styles/login-widget.scss");
var styles = require("./StandardView.scss");
/** LOB Components */
var PageLevelError_1 = require("../../../common/PageLevelError/PageLevelError");
var InlineError_1 = require("../../../common/InlineError/InlineError");
var Password_1 = require("../Password/Password");
/** Api, Reporting, Mappers, Request, Response */
var analytics_1 = require("@login/analytics");
var StateProvider_1 = require("../../../../api/StateProvider");
var Events_1 = require("../../../../api/Events");
var LoginApi_1 = require("../../../../api/LoginApi");
var AuthenticateAndLoginRequest_1 = require("../../../../models/request/AuthenticateAndLoginRequest");
var SavedUserIdHandler_1 = require("../../../common/SaveUserID/SavedUserIdHandler");
var ReportingService_1 = require("../../../../api/ReportingService");
var CommonFunctions_1 = require("../../../common/CommonFunctions/CommonFunctions");
var StandardView = /** @class */ (function (_super) {
    __extends(StandardView, _super);
    // private StandardViewCmsData: StandardViewCms;
    // private InlineErrorsCmsData: InlineErrorsCms;
    function StandardView(props) {
        var _this = _super.call(this, props) || this;
        _this.tGuardMultiLoginStage = 'https://cgatemas.stage.att.com'
            + '/commonLogin/igate_wam/multiLogin.do';
        _this.tGuardTokenServiceStage = 'https://cgate.stage.att.com/TokenService'
            + '/nxsATS/WATokenService?appID={appId}&returnURL={returnUrl}';
        _this.tGuardMultiLoginProd = 'https://cprodmasx.att.com'
            + '/commonLogin/igate_wam/multiLogin.do';
        _this.tGuardTokenServiceProd = 'https://cprodx.att.com/TokenService'
            + '/nxsATS/WATokenService?appID={appId}&returnURL={returnUrl}';
        _this.forgotIDUrl = 'https://m.att.com/my/#/forgotLoginLanding'
            + '?origination_point=login&Flow_Indicator=FID';
        _this.forgotPasswordUrl = 'https://m.att.com/my/#/forgotLoginLanding'
            + '?origination_point=login&Flow_Indicator=FPWD';
        _this.idInvalidCharactersRegexp = /[^a-zA-Z0-9@ ._+-]+/g;
        // readonly idSimpleEmailPattern = /^.+@.+\..+$/g;
        _this.idSimpleEmailPattern = /^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        _this.validateConsecutiveSpecial = /[\-_\.][\-_\.]/;
        _this.idNumberPattern = /^\d+$/g;
        _this.commonLoginSubmit = 'Common_Login_Submit';
        _this.redirectUrl = 'https://www.att.com/shop/unified/authentication.html';
        _this.passwordEntryIsValid = false;
        _this.appIdStage = 'M81162';
        _this.appIdProd = 'M81193';
        _this.idEntryIsValid = false;
        _this.mvpView = true;
        _this.savedUserIdHandler = null;
        _this.commonFunctions = null;
        _this.suppressUserIdPopupLinks = false;
        _this.state = new StandardViewState_1.default();
        _this.api = new LoginApi_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.initializeEvents();
        _this.preventDefault = _this.preventDefault.bind(_this);
        _this.submitLogin = _this.submitLogin.bind(_this);
        _this.analyticsStandardViewFormPageLoad = _this.analyticsStandardViewFormPageLoad.bind(_this);
        _this.suppressUserIdPopupLinks = _this.props && _this.props.options
            && _this.props.options.suppressUserIdPopupLinks;
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        // this.checkForNumricEntry = this.checkForNumricEntry.bind(this);
        if (_this.props.data.saveUserIdHandler) {
            _this.savedUserIdHandler = _this.props.data.saveUserIdHandler;
        }
        else {
            _this.savedUserIdHandler = new SavedUserIdHandler_1.SavedUserIdColamCtn();
        }
        _this.commonFunctions = CommonFunctions_1.CommonFunctions.getInstance();
        return _this;
    }
    StandardView.prototype.componentDidMount = function () {
        // console.info( 'componentDidMount' );
        this.events = new Events_1.default([StandardView.successEventName]);
        console.log('StandardView - loginUrl ' + this.props.data.loginUrl);
        // this.checkForSavedUserId();
        // this.analyticsStandardViewFormPageLoad();
    };
    StandardView.prototype.preventDefault = function () {
        // Prevent the default from being triggered for the
        // form element
        event.preventDefault();
    };
    StandardView.prototype.analyticsStandardViewFormPageLoad = function () {
        this.reportingService
            .analyticsLoginPageLoad('isLoginPageLoadedAlready', ReportingService_1.PageUrls.LOGIN_PAGE, ReportingService_1.PageName.LOGIN_PAGE);
    };
    StandardView.prototype.initializeEvents = function () {
        var _this = this;
        // this.StandardViewCmsData = CMS.get(new StandardViewCms(), 'StandardView').content;
        // this.InlineErrorsCmsData = CMS.get(new InlineErrorsCms(), 'InlineErrors').content;
        this.StandardViewCmsData = cms_integration_1.CMS.get({}, 'login').content.loginConsole;
        this.userIDFieldEvents = {
            onBlur: function (value) {
                _this.analyticsStandardViewFormPageLoad();
                value = value.trim();
                _this.idEntryIsValid = _this.validateUserId(value);
                // console.log( 'idField, onBlur', this.idEntryIsValid, value );
                if (_this.idEntryIsValid) {
                    _this.checkForNumricEntry(value);
                }
            },
            onChange: function (event) {
                // console.log('onChange');
                _this.analyticsStandardViewFormPageLoad();
                _this.checkForNumricEntry(event.currentTarget.value);
            },
            onClear: function (currentValue, e) {
                _this.analyticsStandardViewFormPageLoad();
                _this.setState({
                    userID: '',
                });
            },
            onKeyPress: function (oldValue, e) {
                // console.log('keyCode  =' + e.key  );
                if (e.key === 'Enter') {
                    _this.submitLogin();
                }
            },
        };
        this.passwordPanelEvent = {
            passwordReady: function (isValdPassword, passwordValue, key) {
                // this.passwordEntryIsValid = this.validatePassword( passwordValue )
                _this.analyticsStandardViewFormPageLoad();
                _this.passwordEntryIsValid = isValdPassword;
                if (_this.passwordEntryIsValid) {
                    _this.setState({
                        isPasswordinValid: false,
                        passwordValue: passwordValue,
                        errormessagePasswordComponent: '',
                    }, function () {
                        if (key === 'Enter') {
                            _this.submitLogin();
                        }
                    });
                }
                else {
                    _this.setState({
                        isPasswordinValid: true,
                        errormessagePasswordComponent: '',
                    });
                }
            },
        };
        this.saveIDCheckBoxEvents = {
            onCheckboxChange: function (value) {
                _this.analyticsStandardViewFormPageLoad();
                if (!value.payload) {
                    _this.setState({
                        saveId: false,
                    });
                }
                else {
                    _this.setState({
                        saveId: true,
                    });
                }
            },
        };
        this.signInEvents = {
            onClick: function () {
                _this.analyticsStandardViewFormPageLoad();
                // console.log( 'signInClicked', this.state );
                if (!_this.state.processing) {
                    _this.submitLogin();
                }
            },
        };
    };
    StandardView.prototype.validateUserId = function (userID) {
        var isValid = true;
        if (userID === undefined || userID === null || userID.length === 0
            || userID.length < 5 || userID.length > 50) {
            isValid = false;
            this.setState({
                errorMessage: '',
                isUserIDinValid: true,
                userID: userID,
                userIDErrorMessage: this.StandardViewCmsData.error.invalidUserIdText,
            });
        }
        else if (userID.match(this.idInvalidCharactersRegexp)) {
            isValid = false;
            this.setState({
                errorMessage: '',
                isUserIDinValid: true,
                userID: userID,
                userIDErrorMessage: this.StandardViewCmsData.error.invalidUserIdText,
            });
            this.setState({ userIDErrorMessage: this.StandardViewCmsData.error.invalidUserIdText });
        }
        else if (userID.indexOf('@') !== -1
            && (!userID.match(this.idSimpleEmailPattern)
                || userID.match(this.validateConsecutiveSpecial))) {
            isValid = false;
            this.setState({
                errorMessage: '',
                isUserIDinValid: true,
                userID: userID,
                userIDErrorMessage: this.StandardViewCmsData.error.invalidEmailText,
            });
        }
        else {
            this.setState({
                errorMessage: '',
                isUserIDinValid: false,
                userID: userID,
                userIDErrorMessage: '',
            });
        }
        // console.log( `validateUserId ${isValid}` );
        return isValid;
    };
    StandardView.prototype.checkForNumricEntry = function (value) {
        var userID = value;
        var passedValue = value.replace(/[^a-zA-Z0-9@_+-]/g, '');
        // console.log('checkForNumricEntry passedValue !! ', passedValue);
        // const numberPAttern = this.idNumberPattern.test(passedValue);
        var numberPAttern = passedValue.match(this.idNumberPattern);
        // console.log('numberPAttern !! =' + numberPAttern);
        if (numberPAttern) {
            // console.log('passedValue =' + passedValue
            // + '   this.idNumberPattern.test  ' + numberPAttern);
            if (passedValue.length >= 7) {
                if (passedValue.length > 10) {
                    // console.log('passedValue = ' + passedValue);
                    passedValue = passedValue.substr(0, 3) + '.'
                        + passedValue.substr(3, 3) + '.' + passedValue.substr(6);
                    this.setState({
                        isNumberFormat: true,
                        isUserIDinValid: true,
                        userID: passedValue,
                        userIDErrorMessage: this.StandardViewCmsData.error.wirelessNumberText,
                    });
                }
                else {
                    // console.log(' Number length is less than 10 digit=' + passedValue);
                    passedValue = passedValue.substr(0, 3) + '.'
                        + passedValue.substr(3, 3) + '.' + passedValue.substr(6);
                    this.setState({
                        disabled: false,
                        isNumberFormat: true,
                        isUserIDinValid: false,
                        userID: passedValue,
                        userIDErrorMessage: '',
                    });
                }
            }
        }
        else {
            this.setState({
                disabled: false,
                isNumberFormat: false,
                isUserIDinValid: false,
                userID: userID,
                userIDErrorMessage: '',
            });
        }
    };
    StandardView.prototype.render = function () {
        var userIDClass = [this.state.isUserIDinValid ? inlineStyles.showErrorMsg : ''];
        return (React.createElement("div", null,
            this.state.errorMessage &&
                React.createElement("div", { className: [globalStyles.formRowSm, globalStyles.formRowBtmMd].join(' '), id: "error-focus" },
                    React.createElement(PageLevelError_1.default, { data: {
                            errorMessagePanel: 'STANDARD_VIEW',
                            errorMessageText: this.state.errorMessage,
                            errorMessageType: 'BACKEND_ERROR',
                        }, options: {
                            className: '',
                        }, testId: 'LoginWidget_ErrorMsg' })),
            React.createElement("div", { className: [appStyles.relative, userIDClass].join(' ') },
                React.createElement(Label_1.default, { data: {
                        text: this.StandardViewCmsData.loginWidget.userIdLabel,
                    }, options: {
                        className: appStyles.inputLabel,
                    }, testId: 'LoginWidget_Label_UserID' }),
                !this.suppressUserIdPopupLinks &&
                    React.createElement("span", { className: [styles.customTooltip].join(' ') },
                        React.createElement(Tooltip_1.default, { data: { type: TooltipProps_1.TooltipTypes.INLINE } },
                            React.createElement("h3", null, this.StandardViewCmsData.loginWidget.tooltipHeading),
                            React.createElement("div", null,
                                this.StandardViewCmsData.loginWidget.tooltipSubText,
                                React.createElement("ul", null,
                                    React.createElement("li", null, this.StandardViewCmsData.loginWidget.tooltipListItem1),
                                    React.createElement("li", null, this.StandardViewCmsData.loginWidget.tooltipListItem2),
                                    React.createElement("li", null, this.StandardViewCmsData.loginWidget.tooltipListItem3),
                                    React.createElement("li", null, this.StandardViewCmsData.loginWidget.tooltipListItem4),
                                    React.createElement("li", null, this.StandardViewCmsData.loginWidget.tooltipListItem5)),
                                React.createElement("div", null,
                                    React.createElement(Link_1.default, { data: {
                                            content: this.StandardViewCmsData.loginWidget.tooltipListItemLinkText1,
                                            href: this.StandardViewCmsData.loginWidget.tooltipListItemLinkUrl1,
                                            target: LinkProps_1.TargetType.BLANK,
                                        }, testId: 'LoginWidget_Tooltip_Link_1' })),
                                React.createElement("div", null,
                                    React.createElement(Link_1.default, { data: {
                                            content: this.StandardViewCmsData.loginWidget.tooltipListItemLinkText2,
                                            href: this.StandardViewCmsData.loginWidget.tooltipListItemLinkUrl2,
                                            target: LinkProps_1.TargetType.BLANK,
                                        }, testId: 'LoginWidget_Tooltip_Link_2' }))))),
                React.createElement(TextField_1.default, { data: { input: this.state.userID, name: 'userid' }, options: {
                        accessibility: this.StandardViewCmsData.loginWidget.userIdLabel,
                        type: TextFieldProps_1.TextFieldType.TEXT,
                    }, events: this.userIDFieldEvents, testId: 'LoginWidget_TextField_UserID' }),
                React.createElement(InlineError_1.default, { data: { inlineErrorText: this.state.userIDErrorMessage }, options: {
                        accessibilityText: this.StandardViewCmsData.common.iconErrorAccessibilityText,
                    }, testId: 'LoginWidget_Inline_Error_UserID' })),
            React.createElement(Password_1.default, { data: {
                    passwordErrorMessage: this.state.passwordErrorMessage,
                    showPasswordInvalidError: this.state.isPasswordinValid,
                    backendErrorMessage: this.state.errormessagePasswordComponent,
                }, events: this.passwordPanelEvent }),
            React.createElement("div", { id: "sumbitButton", className: [styles.ctaButtonGroup].join(' ') },
                React.createElement(Button_1.default, { data: {
                        disabled: this.state.disabled,
                        text: this.state.processing ?
                            this.StandardViewCmsData.common.buttonProcessingCTA :
                            this.StandardViewCmsData.common.buttonPrimarySignInCTA,
                    }, events: this.signInEvents, options: { size: ButtonProps_1.ButtonSize.LARGE, showLoader: this.state.processing }, testId: 'LoginWidget_Button_SignIn' })),
            this.props.options && !this.props.options.suppressSavedId &&
                React.createElement("div", { className: [styles.saveId, styles.customCheckbox].join(' ') },
                    React.createElement(Checkbox_1.default, { data: {
                            text: this.StandardViewCmsData.loginWidget.saveUserIdCheckboxLabel,
                            value: this.state.saveId,
                        }, events: this.saveIDCheckBoxEvents, testId: 'LoginWidget_Checkbox_SaveID' }),
                    React.createElement("span", null, this.StandardViewCmsData.loginWidget.saveUserIdCheckboxSubText))));
    };
    StandardView.prototype.submitLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var validationFlag, userID, retreiveUserInfo, request, result, exc_1, errorMessageCounter, uiErrorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        validationFlag = true;
                        if (!this.commonFunctions.notBlankCheck(this.state.userID)) {
                            validationFlag = false;
                            // console.log('userID is  balnk');
                            if (!this.commonFunctions.notBlankCheck(this.state.passwordValue)) {
                                // console.log('password is also blank');
                                validationFlag = false;
                                this.setState({
                                    isPasswordinValid: true,
                                    isUserIDinValid: true,
                                    passwordErrorMessage: this.StandardViewCmsData.error.invalidPasswordText,
                                    userID: this.state.userID,
                                    userIDErrorMessage: this.StandardViewCmsData.error.invalidUserIdText,
                                });
                            }
                            else {
                                this.setState({
                                    isUserIDinValid: true,
                                    userID: this.state.userID,
                                    userIDErrorMessage: this.StandardViewCmsData.error.invalidUserIdText,
                                });
                            }
                        }
                        if (!this.commonFunctions.notBlankCheck(this.state.passwordValue)) {
                            validationFlag = false;
                            // console.log('Just password is blank');
                            this.setState({
                                isPasswordinValid: true,
                                passwordErrorMessage: this.StandardViewCmsData.error.invalidPasswordText,
                            });
                        }
                        if (!validationFlag) {
                            return [2 /*return*/];
                        }
                        // console.log( 'validationFlag 1', validationFlag );
                        if (!this.validateUserId(this.state.userID) ||
                            this.state.isPasswordinValid) {
                            // console.log( 'Please enter Valid User ID and Password',
                            //              this.state.userID, this.state.passwordValue );
                            return [2 /*return*/];
                        }
                        this.setState({
                            processing: true,
                        });
                        // console.log( 'this.state.isNumberFormat ', this.state.isNumberFormat);
                        if (this.state.isNumberFormat) {
                            userID = this.state.userID.replace(/[^0-9]/g, '');
                        }
                        else {
                            userID = this.state.userID.replace(this.idInvalidCharactersRegexp, '');
                            // console.log( 'submitLogin !!', this.state.isNumberFormat, userID, this.state.passwordValue );
                        }
                        this.setState({ userID: userID });
                        retreiveUserInfo = false;
                        if (this.props.data.mvpView) {
                            retreiveUserInfo = true;
                        }
                        request = new AuthenticateAndLoginRequest_1.AuthenticateAndLoginRequest(userID, this.state.passwordValue, this.getReturnUrl(), true, this.state.saveId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.authenticateAndLogin(request)];
                    case 2:
                        result = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        exc_1 = _a.sent();
                        // console.log( 'authenticateAndLogin Failure', exc );
                        this.setState({ errorMessage: exc_1.message, processing: false });
                        return [2 /*return*/];
                    case 4:
                        // This is outside the try block so that any errors in the
                        // setState or fireEvent don't get trapped by catch
                        if (result.error) {
                            console.log('authenticateAndLogin result.error : ', result.error);
                            this.reportingService.fireLoginUIFormResponseEvent(true, result.error.message, result.error.errorId, analytics_1.ErrorTypeOption.Failure_User, 'Sign in', ReportingService_1.PageEventCode.LOGIN_PAGE, ReportingService_1.PageUrls.LOGIN_PAGE, this.state.saveId);
                            errorMessageCounter = this.state.errorMessageCounter;
                            errorMessageCounter++;
                            uiErrorMessage = this.commonFunctions.invalidCredentailsCounter(result, errorMessageCounter, this.state.userID, this.getReturnUrl());
                            console.log('authenticateAndLogin result.error 2 : ', errorMessageCounter + ' ' + uiErrorMessage);
                            this.setState({
                                errorMessageCounter: errorMessageCounter,
                                errorMessage: uiErrorMessage,
                                errormessagePasswordComponent: uiErrorMessage,
                                processing: false,
                            });
                            return [2 /*return*/];
                        }
                        else {
                            this.setState({ disabled: false, processing: false });
                            this.handleSuccessResult(result);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    StandardView.prototype.handleSuccessResult = function (result) {
        // If authenticated we are good to go
        if (result.content.authenticated) {
            // If not MVP View, send event, otherwise handle mvp
            if (!this.props.data.mvpView) {
                this.reportingService.fireLoginUIFormResponseEvent(false, 'success', '0', analytics_1.ErrorTypeOption.Success_Admit, 'Sign in', ReportingService_1.PageEventCode.LOGIN_PAGE, ReportingService_1.PageUrls.LOGIN_PAGE, this.state.saveId);
                this.events.fireEvent({
                    authenticated: true,
                    cancelled: false,
                }, StandardView.successEventName);
            }
            else if (result.content.linkedWirelessAccNums &&
                (result.content.linkedWirelessAccNums.split(',').length === 1
                    && !result.content.passcodeAccountsSuppressed)) {
                this.reportingService.fireLoginUIFormResponseEvent(false, 'success', '0', analytics_1.ErrorTypeOption.Success_Admit, 'Sign in', ReportingService_1.PageEventCode.LOGIN_PAGE, ReportingService_1.PageUrls.LOGIN_PAGE, this.state.saveId);
                // console.log( 'fireEvent event on successful validation');
                this.events.fireEvent({
                    authenticated: true,
                    cancelled: false,
                }, StandardView.successEventName);
            }
            else {
                this.reportingService.fireLoginUIFormResponseEvent(false, 'success', '0', analytics_1.ErrorTypeOption.Success_Admit, 'Sign in', ReportingService_1.PageEventCode.LOGIN_PAGE, this.redirectUrl, this.state.saveId);
                // console.log( 'returned alternate destination - gotoRedirect:', this.redirectUrl );
                /*   this.gotoRedirect( result.content.redirectUrl ); */
                this.commonFunctions.gotoRedirect(this.redirectUrl);
            }
        }
        else {
            /** need redirect to old sales flow */
            if (result.content.invokeTguard) {
                console.log('need to invoke tguard for intercept');
                this.reportingService.fireLoginUIFormResponseEvent(false, 'success', '0', analytics_1.ErrorTypeOption.Success_Admit, 'Sign in', ReportingService_1.PageEventCode.LOGIN_PAGE, this.getReturnUrl(), this.state.saveId);
                this.commonFunctions.invokeTguard(this.state.userID, this.state.passwordValue, this.state.saveId, this.savedUserIdHandler, this.getLoginUrl(), this.getReturnUrl());
            }
            else {
                this.reportingService.fireLoginUIFormResponseEvent(false, 'success', '0', analytics_1.ErrorTypeOption.Success_Admit, 'Sign in', ReportingService_1.PageEventCode.LOGIN_PAGE, result.content.redirectUrl, this.state.saveId);
                // console.log( 'returned alternate destination - redirecting:', this.redirectUrl );
                this.commonFunctions.gotoRedirect(result.content.redirectUrl);
            }
        }
    };
    // Method to go to redirect url
    /* gotoRedirect( url: string ) {
         document.location.href = url;
     } */
    /*
   getTGuardMultiLoginUrlForEnv() {
       const url = document.location.href;
       if ( url.indexOf( 'stage.att.com' ) > -1 ||
           url.indexOf( 'dev.att.com' ) > -1 ) {
           return this.tGuardMultiLoginStage;
       } else {
           return this.tGuardMultiLoginProd;
       }
   }
   */
    /*
    getTGuardTokenServiceUrlForEnv() {
        const url = document.location.href;
        if ( url.indexOf( 'stage.att.com' ) > -1 ||
            url.indexOf( 'dev.att.com' ) > -1 ) {
            return this.tGuardTokenServiceStage;
        } else {
            return this.tGuardTokenServiceProd;
        }
    }
    */
    /*
    getTGuardAppIdForEnv() {
        const url = document.location.href;
        if ( url.indexOf( 'stage.att.com' ) > -1 ||
            url.indexOf( 'dev.att.com' ) > -1 ) {
            return this.appIdStage;
        } else {
            return this.appIdProd;
        }
    }*/
    // Creates a form for invoking tguard directly and posts it.
    /*
    invokeTguard() {
        const multiLoginUrl = this.getTGuardMultiLoginUrlForEnv();
        const tokenServiceUrl = this.getTGuardTokenServiceUrlForEnv();
        const appId = this.getTGuardAppIdForEnv();

        const form = document.createElement( 'form' );
        form.setAttribute( 'method', 'POST' );
        form.setAttribute( 'action', multiLoginUrl );
        form.appendChild( this.createFormElement( 'userid', this.state.userID ) );
        form.appendChild( this.createFormElement( 'password', this.state.passwordValue ) );
        form.appendChild( this.createFormElement( 'lang', 'en' ) );
        form.appendChild( this.createFormElement( 'persist', 'y' ) );

        if ( this.savedUserIdHandler.sendToApi && this.state.saveId ) {
            form.appendChild( this.createFormElement( 'remember_me', 'y' ) );
        }

        form.appendChild( this.createFormElement( 'loginURL', this.getLoginUrl() ) );
        form.appendChild( this.createFormElement( 'cancelURL', this.getLoginUrl() ) );
        let targetUrl = tokenServiceUrl;
        targetUrl = targetUrl.replace( '{appId}', appId );
        targetUrl = targetUrl.replace( '{returnUrl}', this.getReturnUrl() );
        form.appendChild( this.createFormElement( 'targetURL', targetUrl ) );
        form.appendChild( this.createFormElement( 'urlParameters', 'loginComponent=true' ) );
        // Submit and delete the form
        document.body.appendChild( form );
        form.submit();
        form.parentNode.removeChild( form );
    }*/
    /*
    checkForSavedUserId() {
        if ( this.savedUserIdHandler !== null ) {
            const ids = this.savedUserIdHandler.getSavedUserIds();
            if ( ids !== null && ids.length > 0 ) {
                this.setState( { id: ids[ 0 ] } );
            }
        }
    }*/
    StandardView.prototype.getReturnUrl = function () {
        if (this.props.data && this.props.data.returnUrl) {
            return this.props.data.returnUrl;
        }
        else if (this.props.data && this.props.data.loginUrl) {
            return this.props.data.loginUrl;
        }
        else {
            var url = document.location.href +
                (document.location.href.indexOf('?') === -1 ? '?' : '&') +
                'authenticated=true';
            // return 'https://www.att.com/shop/unified/authentication.html';
        }
    };
    StandardView.prototype.getLoginUrl = function () {
        if (this.props.data && this.props.data.loginUrl) {
            return this.props.data.loginUrl;
        }
        else {
            return document.location.href;
        }
    };
    StandardView.successEventName = 'loginSuccessEvent';
    return StandardView;
}(React.Component));
exports.default = StandardView;
//# sourceMappingURL=StandardView.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/StandardView/StandardView.js
// module id = 351
// module chunks = 8